import { useCallback } from 'react'
import { createLogger } from '../../../app/logger'
import useAppSelector from '../../../hooks/useAppSelector'
import { CheckinEntry } from '../../../app/types'
import { getS3AllTeamEntriesSelector } from '../../data/dataSlice'
import { convertToCheckinEntry } from '../hooks/useCheckinDataColumns'
import { removeDiacritics } from '../../../utils/removeDiacritics'

// eslint-disable-next-line no-unused-vars
export const logger = createLogger({
  prefix: 'useEntryFilter'
})

export default function useEntryFilter(textSearch: string) {
  const allTeamEntries = useAppSelector(getS3AllTeamEntriesSelector)

  return useCallback((entry: CheckinEntry) => {
    if (entry.entryType === 'TEAM') return false

    if (textSearch) {
      const matches = (prop: keyof CheckinEntry) => {
        const entryVal = removeDiacritics(String(entry[prop]).toLowerCase())
        if (prop === 'entryId') return entryVal === textSearch

        if (prop === 'teamName') {
          if (entry.teamName && removeDiacritics(entry.teamName.toLowerCase()) === textSearch) {
            return entry.teamName !== entry.fullName && entry.entryType !== 'TEAM'
          }
        }

        if (prop === 'fullName') {
          if (entry.teamId && entry.teamShareBib) {
            const teamMembers = allTeamEntries?.filter(
              x => x.team_id === entry.teamId && x.entry_type !== 'TEAM'
            ).map(convertToCheckinEntry)

            return teamMembers?.some(x =>
              removeDiacritics(x.fullName.toLowerCase()) === textSearch
            )
          }
        }

        if (prop === 'bib') {
          const team = allTeamEntries?.filter(x =>
            x.entry_bib?.includes(textSearch) &&
            x.team_type === 'RELAY' &&
            x.team_share_bib
          ).map(convertToCheckinEntry)[0]

          if (team) {
            const teamMembers = allTeamEntries?.filter(x => x.team_id === team.teamId)
            return teamMembers?.every(x => x.team_id === entry.teamId) || entryVal.includes(textSearch)
          }
        }
        return entryVal.includes(textSearch)
      }
      return matches('firstName') || matches('lastName') ||
        matches('fullName') || matches('entryId') ||
        matches('bib') || matches('tag') || matches('teamName')
    }

    return true
  }, [
    textSearch,
    allTeamEntries
  ])
}
